import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Header } from 'src/app/util/headerTwo';

@Injectable({
  providedIn: 'root',
})
export class ContinteresesService {
  constructor(private http: HttpClient) {}
  header: Header = new Header();

  asignarIntereses(compId: any, idUser: any, valor: any): Observable<any> {
    const body = {
      cartId: compId,
      idUser: idUser,
      valor: valor,
    };
    return this.http.post<any>(
      this.header.url.concat('intereses/asignar/intereses/costas'),
      body,
      { headers: this.header.parametro },
    );
  }

  asignarInteresesNormales(
    compId: any,
    idUser: any,
    valor: any,
  ): Observable<any> {
    const body = {
      cartId: compId,
      idUser: idUser,
      valor: valor,
    };
    return this.http.post<any>(
      this.header.url.concat('intereses/asignar'),
      body,
      { headers: this.header.parametro },
    );
  }
}
